<template>
  <v-app-bar
    color="white"
    class="step-toolbar__content elevation-0 px-0 px-sm-5"
  >
    <v-row>
      <v-col cols="12" class="step-toolbar__col">
        <div v-for="(item, key) of steps" :key="key" class="step-toolbar__step">
          <div class="step-toolbar__line-wrap-left" v-if="key > 0" />
          <v-avatar
            :class="colorStep(item) + ' step-toolbar__step-icon'"
            size="30"
          >
            <v-icon v-if="showIcon(item)" size="17">
              {{ iconStep(item) }}
            </v-icon>
          </v-avatar>
          <div
            class="step-toolbar__line-wrap-right"
            v-if="key < steps.length - 1"
          />
        </div>
      </v-col>
      <v-col cols="12" class="step-toolbar__col">
        <div v-for="(item, key) of steps" :key="key" class="step-toolbar__step">
          <v-toolbar-title :class="colorText(item) + ' justify-center'">
            {{ item.name }}
          </v-toolbar-title>
        </div>
      </v-col>
    </v-row>
  </v-app-bar>
</template>
<script>
export default {
  methods: {
    colorStep(item) {
      const color =
        (this.currentStep.step < item.step && "white") ||
        (this.currentStep.step > item.step && "green") ||
        "yellow";
      return `step-toolbar__background-${color}`;
    },
    colorText(item) {
      const color =
        this.currentStep.step < item.step ? "lightBlue--text" : "primary--text";
      return `step-toolbar__text font-weight-medium ${color}`;
    },
    iconStep(item) {
      const icon =
        (this.currentStep.step > item.step && "fa-check") || "fa-ellipsis-h";
      return icon;
    },
    showIcon(item) {
      return this.currentStep.step >= item.step;
    }
  },
  props: {
    steps: {
      type: Array
    },
    currentStep: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.step-toolbar__
  &background-white
    border: 2px solid #E5E5ED
    background-color: #FFFFFF
  &background-green
    background-color: #49DCBB
  &background-yellow
    background-color: #FFEDB9
  &content
    z-index: 6
    height: 65px
    align-items: center
  &text
    font-size: 14px
    @media(max-width:960px)
      font-size: 12px
  &col
    display: flex
    flex-wrap: wrap
  &step
    flex: 1
    justify-content: center
    text-align: center
    position: relative
  &line-wrap-left
    width: 50%
    border: 1px solid rgba(213,213,224,0.51)
    top: 50%
    position: absolute
  &line-wrap-right
    width: 50%
    border: 1px solid rgba(213,213,224,0.51)
    top: 50%
    position: absolute
    right: 0
  &step-icon
    z-index: 1
</style>
